<template>
    <el-dialog title="导入搜索" width="500px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-input placeholder="请选择文件" v-model="excel_file_name" disabled>
            <template #append>
                <el-button type="primary" @click="excel_file_input.click()">选择文件</el-button>
            </template>
        </el-input>
        <input ref="excel_file_input" type="file" accept=".xlsx,.xls" @change="fileChange" style="display: none" />
        <p style="margin-top: 10px">支持.xls,.xlsx格式的文件</p>
        <span style="display: inline-block; margin-top: 10px; color: blue; cursor: pointer" @click="downloadTem">模板下载</span>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
        <div class="downLoadTemplateMask" v-if="downloadTemplateMaskVisible">
            导入模板正在生成中，可能需要5-10分钟，请耐心等待。
        </div>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref } from 'vue'
import { downloadTemplate } from '@/api/sys.js'
import { ElMessage } from 'element-plus'
import * as XLSX from 'xlsx'

const emits = defineEmits(['update:modelValue', 'updateForm'])
const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    menuCode: {
        type: String,
        required: true
    },
    paramsData: {
        type: Object,
        required: false,
        default: () => {
            return {}
        }
    }
})

const submitLoading = ref(false)

// 关闭弹窗
function closed() {
    emits('update:modelValue', false)
    excel_file_name.value = ''
    excel_data.value = []
}

// 文件选择
const excel_file_name = ref('')
const excel_file_input = ref(null)
const excel_data = ref([])
function fileChange(event) {
    const file = event.target.files[0]
    excel_file_input.value.value = ''
    excel_file_name.value = file.name

    const reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onload = (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, { type: 'array' })
        const firstSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firstSheetName]
        const jsonData = XLSX.utils.sheet_to_json(worksheet)
        if (jsonData.length === 0) {
            ElMessage.error('导入文件为空，请重新选择文件')
        } else {
            excel_data.value = jsonData.map((item) => item['IMEI*'])
        }
    }
}

// 点击下载模板时启用遮罩层
const downloadTemplateMaskVisible = ref(false)
const downloadTem = async () => {
    if (props.menuCode === 'event/linkage') {
        ElMessage.success('正在下载导入模板，该过程可能需要5分钟，请在当前页面等待...')
        downloadTemplateMaskVisible.value = true
    }
    try {
        const data = await downloadTemplate(props.menuCode, props.paramsData)
        window.open(data.data)
        downloadTemplateMaskVisible.value = false
    } catch (e) {}
}

const onConfirm = () => {
    if (excel_data.value.length > 100) {
        ElMessage.error('最多导入100个IMEI，请重新选择文件')
        return
    }
    emits('updateForm', excel_data.value)
    closed()
}
</script>

<style lang="scss" scoped>
:deep(.el-input-group__append, .el-input-group__prepend) {
    background-color: var(--theme-color);
    color: #ffffff;
}
.downLoadTemplateMask {
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    background: rgba($color: #333, $alpha: 0.7);
    position: fixed;
    left: 0;
    top: 0;
    line-height: 100vh;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #de9324;
}
</style>
